import React from 'react';

import classes from './Spinner.css';

const spinner = (props) => {

  let spinnerClass = classes.Loader;
  if (props.inline) {
    spinnerClass = classes.LoaderInline;
  }

  let style = {};
  if (props.margin) {
    style['margin'] = props.margin;
  }
  if (props.fontSize) {
    style['fontSize'] = props.fontSize;
  }

  return (
    <div
      className={[spinnerClass, props.extraClass ? props.extraClass : null].join(' ')}
      style={style}>
      Loading...
    </div>
  );
};

export default spinner;



// WEBPACK FOOTER //
// ./src/components/UI/Spinner/Spinner.js